import React from 'react';

import { FormattedMessage } from 'react-intl';
import { all, call, put, takeEvery } from 'redux-saga/effects';

import {
  getBankingDetailsFailure,
  getBankingDetailsSuccess,
  setBankingDetailsSuccess,
} from '@actions/vatNumbers';
import { getBankingDetails, setBankingDetails } from '@api/bankingDetails';
import types from '@constants/action-types';
import bankDetailsSet from '@models/BankDetails/bankDetailsSet';
import { specialConsiderationsRoutes } from '@routes';
import { history } from '@routes/history';
import { toastError, toastSuccess } from '@store/notifications';

export const handleSetBankingDetailsRequest = function* ({ payload }) {
  try {
    const response = yield call(setBankingDetails, {
      data: bankDetailsSet(payload.data),
      regId: payload.regId,
    });

    yield put([
      setBankingDetailsSuccess(response),
      toastSuccess({
        id: 'set-banking-details-success',
        message: (
          <FormattedMessage
            defaultMessage="Bank details saved successfully."
            id="components.banking-details-form.server-success.default"
          />
        ),
      }),
    ]);

    yield call(
      history.push,
      specialConsiderationsRoutes.BANKING_DETAILS.make(payload.entityId, payload.regId)
    );
  } catch (errors) {
    const { fieldErrors, nonFieldErrors, hasNonFieldError, hasFieldError } = errors.data || {};

    if (hasFieldError) {
      yield call(payload.setErrors, fieldErrors);
    }

    if (hasNonFieldError || !hasFieldError) {
      yield put(
        toastError({
          id: 'set-banking-details-error',
          message: hasNonFieldError ? (
            nonFieldErrors
          ) : (
            <FormattedMessage
              defaultMessage="An error occurred. Please try again."
              id="components.banking-details-form.server-error.default"
            />
          ),
        })
      );
    }

    yield call(payload.setSubmitting, false);
  }
};

export const handleGetBankingDetailsRequest = function* ({ payload }) {
  try {
    const response = yield call(getBankingDetails, payload);
    yield put(getBankingDetailsSuccess(response));
  } catch (e) {
    yield put(getBankingDetailsFailure(e));
  }
};

export default all([
  takeEvery(types.SET_BANKING_DETAILS_START, handleSetBankingDetailsRequest),
  takeEvery(types.GET_BANKING_DETAILS_START, handleGetBankingDetailsRequest),
]);
